var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Buttons',{attrs:{"colors":_vm.colors},model:{value:(_vm.score),callback:function ($$v) {_vm.score=$$v},expression:"score"}})}
var staticRenderFns = []

export { render, staticRenderFns }